(() => {
  // An exact size must use variant-level filtering, rather than Shopify's fuzzy search.
  const parseSize = value => {
    const match = String(value || '').trim().match(/^(\d{3})\s*\/\s*(\d{2})\s*Z?R\s*(\d{2})$/i);
    return match ? match[1] + '/' + match[2] + 'R' + match[3] : '';
  };
  window.CavrenloTireSearch = Object.freeze({ parseSize });
  const sizeSearchUrl = (form, size) => {
    const url = new URL(form.dataset.tireCatalogUrl, location.origin);
    const current = new URLSearchParams(location.search);
    if (current.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.get('preview_theme_id'));
    url.searchParams.set('tire_size', size);
    return url.pathname + url.search;
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[data-tire-catalog-url]')) return;
    const size = parseSize(form.elements.namedItem('q')?.value);
    if (!size) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(sizeSearchUrl(form, size));
  }, true);
  // Also correct bookmarked/shared size-search URLs that bypass the header form.
  const searchForm = document.querySelector('form[data-tire-catalog-url]');
  const querySize = parseSize(new URLSearchParams(location.search).get('q'));
  if (searchForm && querySize && location.pathname === new URL(searchForm.action, location.origin).pathname) {
    location.replace(sizeSearchUrl(searchForm, querySize));
    return;
  }
  const sizes = [];
  document.querySelectorAll('[data-size-options]').forEach(node => {
    try { JSON.parse(node.textContent).forEach(title => {
      const match = title.match(/(\d{3})\/(\d{2})Z?R(\d{2})/);
      if (match && !sizes.some(s => s.key === match.slice(1).join('-'))) sizes.push({ width:match[1], ratio:match[2], rim:match[3], key:match.slice(1).join('-') });
    }); } catch (error) { console.warn('Unable to load tire sizes', error); }
  });
  const params = new URLSearchParams(location.search);
  const selectedSize = parseSize(params.get('tire_size')) || params.get('tire_size') || '';
  const setOptions = (select, values, label) => {
    select.replaceChildren(new Option(label, ''));
    [...new Set(values)].sort((a,b) => Number(a)-Number(b)).forEach(value => select.add(new Option(value,value)));
    select.disabled = !values.length;
  };
  document.querySelectorAll('[data-size-finder]').forEach(finder => {
    const width = finder.querySelector('[data-width]'), ratio = finder.querySelector('[data-ratio]'), rim = finder.querySelector('[data-rim]');
    setOptions(width, sizes.map(s=>s.width), 'Select width');
    const updateRatio=()=>{setOptions(ratio,sizes.filter(s=>s.width===width.value).map(s=>s.ratio),'Select ratio');setOptions(rim,[],'Select diameter');};
    const updateRim=()=>setOptions(rim,sizes.filter(s=>s.width===width.value && s.ratio===ratio.value).map(s=>s.rim),'Select diameter');
    width.addEventListener('change',updateRatio); ratio.addEventListener('change',updateRim);
    const current = selectedSize.match(/(\d{3})\/(\d{2})Z?R(\d{2})/);
    if(current){width.value=current[1];updateRatio();ratio.value=current[2];updateRim();rim.value=current[3];}
    finder.querySelector('form').addEventListener('submit',event=>{
      event.preventDefault();
      if(!width.value || !ratio.value || !rim.value) return;
      const url=new URL(finder.dataset.catalogUrl,location.origin);
      if(params.has('preview_theme_id')) url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
      url.searchParams.set('tire_size',width.value+'/'+ratio.value+'R'+rim.value);
      location.assign(url.pathname+url.search);
    });
  });
  document.querySelectorAll('[data-tire-catalog]').forEach(catalog => {
    const grid=catalog.querySelector('[data-product-grid]'),cards=[...grid.querySelectorAll('[data-product-card]')];
    const brand=catalog.querySelector('[data-brand-filter]'),type=catalog.querySelector('[data-type-filter]'),sort=catalog.querySelector('[data-sort-filter]');
    const money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
    const normalized=value=>value.replace('ZR','R');
    cards.forEach((card,index)=>{card.originalIndex=index;card.variants=JSON.parse(card.querySelector('[data-tire-variants]').textContent);});
    brand.value=params.get('brand')||'';type.value=params.get('type')||'';
    const apply = () => {
      let count=0;
      cards.forEach(card=>{
        const variant = selectedSize ? card.variants.find(v=>normalized(v.title.split(' ')[0])===normalized(selectedSize)) : null;
        const show=(!brand.value || card.dataset.brand===brand.value) && (!type.value || card.dataset.type===type.value) && (!selectedSize || variant);
        card.hidden=!show;
        if(show) count++;
        if(variant){
          card.dataset.price=variant.price;
          card.querySelector('[data-spec]').textContent=variant.title;
          card.querySelector('[data-tire-price]').textContent=money.format(variant.price/100)+' USD / tire';
          card.querySelectorAll('[data-tire-link]').forEach(a=>a.href=variant.url);
          if(variant.image){const img=card.querySelector('img');img.srcset='';img.src=variant.image;img.alt=card.dataset.title+' '+variant.title;}
        }
      });
      cards.sort((a,b)=>sort.value==='price-up'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='price-down'?Number(b.dataset.price)-Number(a.dataset.price):sort.value==='name'?a.dataset.title.localeCompare(b.dataset.title):a.originalIndex-b.originalIndex).forEach(card=>grid.append(card));
      catalog.querySelector('[data-result-count]').textContent=count+' '+(count===1?'model':'models')+(selectedSize?' in '+selectedSize:'');
      catalog.querySelector('[data-no-results]').hidden=count>0;
    };
    [brand,type,sort].forEach(select=>select.addEventListener('change',()=>{apply();const u=new URL(location.href);brand.value?u.searchParams.set('brand',brand.value):u.searchParams.delete('brand');type.value?u.searchParams.set('type',type.value):u.searchParams.delete('type');history.replaceState(null,'',u);}));
    catalog.querySelectorAll('[data-reset-filters]').forEach(button=>button.addEventListener('click',()=>{const u=new URL(location.href);['tire_size','brand','type'].forEach(k=>u.searchParams.delete(k));location.assign(u.pathname+u.search);}));
    const sizeLabel=catalog.querySelector('[data-active-size]');
    if(selectedSize){sizeLabel.hidden=false;sizeLabel.textContent='Showing tire size: '+selectedSize+'. Check load index and speed rating on the product page.';}
    apply();
  });
})();
